
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connectedHive",
      function () {
        return require("private-next-pages/connectedHive/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connectedHive"])
      });
    }
  